import React from 'react';
import { Instagram, Heart, MessageCircle } from 'lucide-react';
import { businessInfo } from '../data/mock';

const InstagramFeed = () => {
  const posts = [
    { id: 1, image: 'muay_thai_action_v2_1774630267798.png', likes: 124, comments: 12 },
    { id: 2, image: 'jiujitsu_action_premium_1774630242434.png', likes: 89, comments: 8 },
    { id: 3, image: 'boxing_action_premium_1774630315645.png', likes: 156, comments: 24 },
    { id: 4, image: 'kickfit_action_premium_v2_1774632260134.png', likes: 210, comments: 15 },
    { id: 5, image: 'martial_arts_kids_premium_1774630331375.png', likes: 342, comments: 42 },
    { id: 6, image: 'header_hero_clean_1774630439252.png', likes: 178, comments: 19 }
  ];

  return (
    <section className="py-24 bg-bg-page border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="p-2 bg-gradient-to-tr from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] rounded-lg">
                <Instagram className="w-6 h-6 text-white" />
              </div>
              <span className="text-sm font-black uppercase tracking-[0.2em] text-brand-primary">Siga-nos</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              Energia Real no <span className="text-brand-primary">Instagram</span>
            </h2>
          </div>
          
          <a
            href={`https://instagram.com/${businessInfo.instagram.replace('@', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary group"
          >
            {businessInfo.instagram}
            <Instagram className="w-5 h-5 ml-2 group-hover:rotate-12 transition-transform" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {posts.map((post) => (
            <a
              key={post.id}
              href={`https://instagram.com/${businessInfo.instagram.replace('@', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative aspect-square overflow-hidden rounded-xl group bg-bg-card"
            >
              <img
                src={post.image}
                alt="Instagram post"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 group-hover:rotate-2"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center space-x-6">
                <div className="flex items-center text-white space-x-1.5">
                  <Heart className="w-5 h-5 fill-white" />
                  <span className="font-bold">{post.likes}</span>
                </div>
                <div className="flex items-center text-white space-x-1.5">
                  <MessageCircle className="w-5 h-5 fill-white" />
                  <span className="font-bold">{post.comments}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
